(function () {
  var UPLOAD_URL = 'https://script.google.com/macros/s/AKfycbwLdGDCXKkOJe8oyrDKohXGDJ2c-AVZrK_7Bz9A269mS768InekKCrcdphsJyRm3Jk/exec';

  document.querySelectorAll('[id^="personalisation-"]').forEach(function (wrapper) {
    var sectionId = wrapper.id.replace('personalisation-', '');
    init(sectionId);
  });

  function init(sectionId) {
    var wrapper      = document.getElementById('personalisation-' + sectionId);
    var photoSection = document.getElementById('photo-section-' + sectionId);
    var symbolSection= document.getElementById('symbol-section-' + sectionId);
    var fileInput    = document.getElementById('photo-file-' + sectionId);
    var uploadingMsg = document.getElementById('uploading-msg-' + sectionId);
    var photoWarning = document.getElementById('photo-warning-' + sectionId);
    var imageUrlInput= document.getElementById('image-url-' + sectionId);
    var symbolInput  = document.getElementById('symbol-input-' + sectionId);
    var radios       = wrapper.querySelectorAll('.personalisation-radio');

    var formId       = imageUrlInput && imageUrlInput.getAttribute('form');
    var productForm  = formId && document.getElementById(formId);
    var submitBtn    = document.getElementById('ProductSubmitButton-' + sectionId);

    // --- Radio toggle: photo vs symbol ---
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.value === 'photo') {
          photoSection.style.display = '';
          symbolSection.style.display = 'none';
          if (symbolInput) symbolInput.value = '';
        } else {
          symbolSection.style.display = '';
          photoSection.style.display = 'none';
          if (imageUrlInput) imageUrlInput.value = '';
          if (photoWarning) photoWarning.style.display = 'none';
        }
      });
    });

    // --- File upload ---
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = this.files[0];
        if (!file) return;

        uploadingMsg.style.display = '';
        photoWarning.style.display = 'none';
        if (submitBtn) submitBtn.disabled = true;

        var reader = new FileReader();
        reader.onload = function (e) {
          var base64 = e.target.result.split(',')[1];
          var payload = JSON.stringify({
            fileName: file.name,
            mimeType: file.type || 'application/octet-stream',
            fileData: base64
          });

          fetch(UPLOAD_URL, { method: 'POST', body: payload })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              uploadingMsg.style.display = 'none';
              if (submitBtn) submitBtn.disabled = false;
              if (data.success && data.url) {
                imageUrlInput.value = data.url;
              } else {
                imageUrlInput.value = '';
                alert('Upload failed. Please try again or contact us.');
              }
            })
            .catch(function () {
              uploadingMsg.style.display = 'none';
              if (submitBtn) submitBtn.disabled = false;
              imageUrlInput.value = '';
              alert('Upload failed. Please check your connection and try again.');
            });
        };
        reader.readAsDataURL(file);
      });
    }

    // --- Form submit: warning + cleanup ---
    if (productForm) {
      productForm.addEventListener('submit', function () {
        var chosen = wrapper.querySelector('.personalisation-radio:checked');
        if (chosen && chosen.value === 'photo') {
          if (symbolInput) symbolInput.value = '';
          if (!imageUrlInput.value) {
            photoWarning.style.display = '';
          }
        } else if (chosen && chosen.value === 'symbol') {
          if (imageUrlInput) imageUrlInput.value = '';
        }
      });
    }
  }
})();
